import { RequestDcmCodes } from './request-dcmcodes';
export class RequestServiceConfiguration {
    dcmCodes: RequestDcmCodes;
}
